import { useEffect, useState } from "react";
import CartiglioData from "../../types/cartiglio";

const useCartigliLoader = (userName: string = "") => {
  const [cartigli, setCartigli] = useState<CartiglioData[]>([]);

  useEffect(() => {
    if (!userName) return;

    userName?.split(" ").forEach((word) => {
      if (cartigli.find((l) => l.length === word.length)) {
        return;
      }

      fetch(`/assets/animated-cartigli/Cartiglio_${word.length}.json`).then(
        (response) => {
          response.json().then((data) => {
            setCartigli((prev) => [...prev, { length: word.length, data }]);
          });
        },
      );
    });
  }, [cartigli, userName, setCartigli]);

  return cartigli;
};

export default useCartigliLoader;
